import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../core/core.module';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DashboardService } from './services/dashboard.service';

@NgModule({
  imports: [CommonModule, CoreModule],
  exports: [DashboardComponent],
  declarations: [DashboardComponent],
  providers: [DashboardService],
})
export class DashboardModule {}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/dashboard/dashboard.module.ts